import OnlineAppComponent from "../lib/online_app_component";
import {getThrottledFunction} from "../../helpers/throttle";

export const OnlineAppMainConfig = {
    baseHtmlClass: "online_app__main",
    selector: ".online_app__main",
};

export class OnlineAppMain extends OnlineAppComponent {
    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppMainConfig);
        if (!this.element) {
            return;
        }
        this.ticking = false;

        const resizeHandler = getThrottledFunction(this.handleResize.bind(this), 100);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(this.element);
    }

    handleResize(event) {
        this.render();
    }

    getFooterHeight() {
        try {
            return this.onlineApp.footer.element.offsetHeight;
        } catch {
            return 0;
        }
    }

    getAuxHeaderHeight() {
        try {
            return this.onlineApp.aux.header.getHeight();
        } catch {
            return 0;
        }
    }

    getTopElementsHeight() {
        return 0;
    }

    getBottomElementsHeight() {
        let height = 0;
        height += this.getFooterHeight();
        height += this.getAuxHeaderHeight();
        return height;
    }

    renderPosition() {
        this.element.style.top = `${this.getTopElementsHeight()}px`;
        this.element.style.bottom = `${this.getBottomElementsHeight()}px`;
    }

    render() {
        this.renderPosition();
    }
}

export function getMain(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppMain(element, onlineApp);
}
